/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryResponse,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods500,
} from "../../types/individualPaymentLookupsController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods.ts";

function getGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsUrl(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsPathParams["financialPersonId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/financial-people/${financialPersonId}/available-payment-methods` as const,
  };
  return res;
}

/**
 * @description Migrado do legado IndividualPayment/GetAvailablePaymentMethodsByPerson. **(Requer Authorization para autenticação)**
 * @summary Métodos de pagamento disponíveis no plano do aluno (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/available-payment-methods}
 */
export async function getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsPathParams["financialPersonId"],
  params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsUrl(
      financialPersonId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
